<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">SGK Meslek Kodu</label>
            <v-select-list v-model="jobCode" :options="jobCodes" label="Combine" v-on:search="searchOT" placeholder="SGK Meslek Kodu" :loading="loading"></v-select-list>
        </div>
        <div class="col-12 mt-2">
                <label class="form-label">Kod Başlangıç Tarihi</label>
                <v-date-picker v-model="value.Date" placeholder="Kod Başlangıç Tarihi"/>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'

export default {
    props:{
        value:Object
    },
    data(){
        return{
            jobCodes:[],
            loading:false
        }
    },
    methods:{
        searchOT(search){
            if(search){
                this.loading = true
                SystemDataApi.OccupationTitlePrefix(search)
                .then(res=>{
                    this.jobCodes = res.data.Data?.map(d=>({
                        ...d,
                        Combine:[d.SGKOccupationCode,d.Name].join(' - ')
                    }))
                    this.loading = false
                }).catch(err=>{ 
                    this.loading = false 
                })
            }
        },
    },
    computed:{
        jobCode:{
            get:function(){
                return this.jobCodes.find(i=>i.Id==this.value.OccupationTitleId)
            },
            set:function(value){
                this.value.OccupationTitleId = value?.Id || null
            }
        },
    }
}
</script>

<style>

</style>